import ROUTES from './routes';

export const ZSB_PRICING_PAGE = ROUTES.SUBSCRIPTION;

export const ZSB_CONTACT = 'https://www.zeroshotbot.com/contact';
